import { normalizeText } from "util/i18n/renderedTranslations";
const MAX_TEXT_LENGTH = 2e3;
const MAX_DOM_PATH_DEPTH = 6;
const closestElement = (target) => {
  if (target instanceof HTMLElement) {
    return target;
  }
  if (target instanceof Node) {
    return target.parentElement;
  }
  return null;
};
export const textOfTarget = (target) => {
  var _a, _b, _c;
  const selection = (_b = (_a = window.getSelection) == null ? void 0 : _a.call(window)) == null ? void 0 : _b.toString();
  if (selection && normalizeText(selection)) {
    return normalizeText(selection).slice(0, MAX_TEXT_LENGTH);
  }
  const element = closestElement(target);
  if (!element) {
    return "";
  }
  const text = element.innerText || element.textContent || element.getAttribute("title") || element.getAttribute("aria-label") || ((_c = element.closest("[title]")) == null ? void 0 : _c.getAttribute("title")) || "";
  return normalizeText(text).slice(0, MAX_TEXT_LENGTH);
};
const describeElement = (element) => {
  const testId = element.getAttribute("data-testid");
  if (element.id) {
    return `${element.tagName.toLowerCase()}#${element.id}`;
  }
  return testId ? `${element.tagName.toLowerCase()}[data-testid="${testId}"]` : element.tagName.toLowerCase();
};
export const domPathOfTarget = (target) => {
  const parts = [];
  let element = closestElement(target);
  while (element && element !== document.body && parts.length < MAX_DOM_PATH_DEPTH) {
    parts.unshift(describeElement(element));
    if (element.id) {
      break;
    }
    element = element.parentElement;
  }
  return parts.join(" > ");
};
export const isEditableTarget = (target) => {
  const element = closestElement(target);
  return !!(element == null ? void 0 : element.closest('input, textarea, select, [contenteditable="true"], .ace_editor, .cm-editor'));
};
